import React, { Component, Fragment } from 'react'
import { Field, reduxForm } from 'redux-form'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'

// COMPONENTS
import { ButtonContained } from '../app-button/button'
import Spinner from '../spinner'
import renderSelectField from './field/customSelect'
import MenuItem from '@material-ui/core/MenuItem'
import MultiSelect from './field/multiSelect'
import { required, requiredMultiSelect } from './validation/validation'
import Tooltip from '@material-ui/core/Tooltip'

const styles = theme => ({
  form: {
    maxWidth: 340,
    width: '100%',
  },
  chip: {
    width: '100%',
    marginBottom: 16,
  },
  root: {
    paddingLeft: 21,
    paddingRight: 3,
    borderRadius: 4,
    height: 48,
    justifyContent: 'flex-start',
  },
  colorSecondary: {
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  deleteIcon: {
    color: '#000',
    marginLeft: 'auto',
    '&:hover': {
      color: '#000',
    },
  },
  label: {
    paddingLeft: 0,
  },
  fieldGroupe: {
    display: 'flex',
  },
  '@keyframes wiggle': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  wiggle: {
    willChange: 'transform',
    animationName: 'wiggle',
    animationDuration: '150ms',
    animationIterationCount: 4,
  },
  crmDescriptionSmall: {
    marginTop: '20px',
    marginBottom: '5px',
    opacity: '0.75',
    fontSize: '12px',
  },
  error: {
    padding: '10px 0',
    fontSize: '12px',
    color: '#ff4e44',
  },
  hintIcon: {
    position: 'absolute',
    top: -6,
    right: 0,
    display: 'block',
    width: 24,
    height: 24,
    border: '1px solid rgb(136, 102, 255)',
    borderRadius: '50%',
    lineHeight: '22px',
    color: 'rgb(255, 255, 255)',
    fontWeight: 600,
    cursor: 'pointer',
    backgroundColor: 'rgb(136, 102, 255)',
    textAlign: 'center',
  },
  hintHelp: {
    textAlign: 'left',
    padding: '4px 8px',
  },
  labelRow: {
    position: 'relative',
  },
})

class YClientsForm2 extends Component {
  state = {
    destination: null,
    text: 'Отправка данных в Электронную торговлю позволяет передавать идентификатор сделки, сумму сделки, факт оплаты или возврата по сделке.\n' +
      'После подключения коннектора мы включим Электронную коммерцию в выбранном ранее представлении Google Analytics.'
  }

  handleClick = (classes, submitFailed) => {
    if (submitFailed) {
      this.form.classList.remove(classes.wiggle)

      void this.form.offsetWidth

      this.form.classList.add(classes.wiggle)
    }
  }

  handleChangeDestination = event => {
    if (event.target.value == 'ecom') {
      this.setState({text: 'Отправка данных в Электронную торговлю позволяет передавать идентификатор сделки, сумму сделки, факт оплаты или возврата по сделке.\n' +
          'После подключения коннектора мы включим Электронную коммерцию в выбранном ранее представлении Google Analytics.'})
    } else {
      this.setState({text: 'Отправка данных в Цель позволяет передать только факт продажи и сумму сделки. После подключения коннектора мы создадим цель "Успешные продажи AMO" в выбранном ранее представлении Google Analytics.'})
    }

    this.setState({ destination: event.target.value })
  }

  render() {
    const {
      classes,
      handleSubmit,
      submitFailed,
      invalid,
      error,
      isFetching,
    } = this.props

    if (
      state.account.import_destination &&
      state.account.import_destination == 'ecom'
    ) {
      this.state.destination = state.account.import_destination
    }

    const menuItem = item => {
      return (
        <MenuItem value={item.id} key={item.id}>
          {item.name}
        </MenuItem>
      )
    }

    const menuItem2 = item => {
      return (
        <MenuItem value={item.NAME} key={item.ID}>
          {item.NAME}
        </MenuItem>
      )
    }

    const menuStatusItem = item => {
      return (
        <MenuItem value={item.STATUS_ID} key={item.ID}>
          {item.NAME}
        </MenuItem>
      )
    }

    const destinations = () => {
      let list = []

      for (let i in state.destinations) {
        list.push(menuItem(state.destinations[i]))
      }

      return list
    }

    const statuses = () => {
      let list = []

      for (let i in state.availableStatuses) {
        list.push(menuStatusItem(state.availableStatuses[i]))
      }

      return list
    }

    const optionsStatus = state.availableStatuses.reduce((options, value) => {
      options.push({
        label: value.NAME,
        value: value.STATUS_ID,
      })

      return options
    }, [])

    const fields = () => {
      let list = []

      for (let i in state.availableFields) {
        list.push(menuItem2(state.availableFields[i]))
      }

      return list
    }

    return (
      <form
        onSubmit={handleSubmit}
        className={cx(
          classes.form,
          { [classes.wiggle]: submitFailed },
          { [classes.novalidate]: invalid }
        )}
        ref={form => (this.form = form)}
      >
        <div className={classes.crmColumn}>
          <div className={classes.labelRow}>
            <div className={classes.crmDescriptionSmall}>
              Выберите, куда хотите отправлять данные
            </div>
            <Tooltip
              interactive
              disableFocusListener
              PopperProps={{
                disablePortal: true,
              }}
              classes={{
                tooltip: classes.hint,
                popper: classes.popper,
              }}
              title={
                <Fragment>
                  <div className={classes.hintHelp}>
                    <p>
                      {this.state.text}
                    </p>
                  </div>
                </Fragment>
              }
            >
              <span className={classes.hintIcon}>?</span>
            </Tooltip>
            <Field
              name="destination"
              validate={[required]}
              component={renderSelectField}
              onChange={this.handleChangeDestination}
            >
              <MenuItem value="" style={{ display: 'none' }}>
            <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
              Выберите, куда хотите отправлять данные
            </span>
              </MenuItem>
              {destinations()}
            </Field>
          </div>
        </div>

        <div className={classes.labelRow}>
          <div className={classes.crmDescriptionSmall}>
            Выберите филиалы для отправки <b>продаж</b> в GA
          </div>
          <Field
            name="pipelines"
            component={MultiSelect}
            options={optionsStatus}
            placeholder="Выберите статусы в вашей CRM"
            validate={[requiredMultiSelect]}
          ></Field>
        </div>


        <div className={classes.crmDescriptionSmall}>
          Выберите поле в вашей CRM, в которое передается Google Client ID.
        </div>
        <Field name="field" component={renderSelectField} validate={[required]}>
          <MenuItem value="" style={{ display: 'none' }}>
            <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>Не выбрано</span>
          </MenuItem>
          {fields()}
        </Field>
        <br/>

        {error ? <div className={classes.error}>{error}</div> : ''}
        <ButtonContained
          style={{
            flexShrink: 0,
            fontSize: 16,
            width: '100%',
            height: 48,
            padding: 0,
            fontWeight: 700,
            color: '#fff',
          }}
          type="submit"
          color="secondary"
          onClick={() => this.handleClick(classes, submitFailed)}
          text={isFetching ? <Spinner /> : 'Подключить'}
        />
      </form>
    )
  }
}

YClientsForm2 = reduxForm({
  form: 'YClientsForm2',
})(YClientsForm2)

export default withStyles(styles)(YClientsForm2)
